export const slugify = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
    .slice(0, 80);

export const emptyPost = {
  slug: "", title_fr: "", title_en: "", excerpt_fr: "", excerpt_en: "",
  body_fr: "", body_en: "", tag_fr: "", tag_en: "", cover_url: "", published: false,
};
